import React, {Component} from 'react'
import {Breadcrumb, Card, Col, Icon, Layout, message, Row, Tabs} from 'antd'
import {withRouter} from 'react-router-dom'
import Governments from '../../../api/Governments'
import Members from '../../../api/Members'
import Details from './Details'
import Profile from './Profile'
import Documents from '../../Common/Documents/DocumentsCont'
import Contracts from '../../../components/Corporate/Government/Contracts'

const {Content} = Layout
const {TabPane} = Tabs

class Government extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.state = {
      member: {},
      government: {},
      repsList: [],
      memberFetching: true,
      governmentFetching: true,
    }
  }

  api = new Governments()
  memberApi = new Members()

  async componentDidMount() {
    try {
      const government = await this.api.getMember(this.key)
      const memberResponse = await this.memberApi.get(this.key)
      let member = await memberResponse.json()
      let response = await this.memberApi.representatives.list(member._key)
      const repsList = await response.json()
      this.setState({
        member,
        government,
        repsList,
        memberFetching: false,
        governmentFetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        memberFetching: false,
        governmentFetching: false,
      })
    }
  }

  render() {
    const {member, government, repsList, memberFetching} = this.state
    return (
      <Content style={{margin: '0px 0px'}}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Corporates</Breadcrumb.Item>
              <Breadcrumb.Item href="#/corporates/governments/list">
                Governments List
              </Breadcrumb.Item>
              <Breadcrumb.Item>{member.fn}</Breadcrumb.Item>
            </Breadcrumb>
          </Row>
        </Card>
        <Row gutter={16} style={{padding: 10}}>
          <Col span={24}>
            <Row style={{paddingTop: '10px'}}>
              <Card style={{minHeight: '542px'}}>
                <Details
                  government={government}
                  member={member}
                  loading={memberFetching}
                />
                <Row style={{paddingTop: '10px'}}>
                  <Tabs defaultActiveKey="1">
                    <TabPane
                      disabled
                      tab={
                        <span>
                          <Icon type="dashboard" />Overview
                        </span>
                      }
                      key="dashboard"
                    />
                    <TabPane
                      tab={
                        <span>
                          <Icon type="user" />Profile
                        </span>
                      }
                      key="1">
                      <Profile
                        repsList={repsList}
                        member={member}
                        loading={memberFetching}
                      />
                    </TabPane>
                    <TabPane
                      tab={
                        <span>
                          <Icon type="lock" />Contracts
                        </span>
                      }
                      key="4">
                      <Contracts employee={government} member={member} />
                    </TabPane>
                    <TabPane
                      tab={
                        <span>
                          <Icon type="folder-open" />Documents
                        </span>
                      }
                      key="7">
                      <Documents owner={government} member={member} />
                    </TabPane>
                  </Tabs>
                </Row>
              </Card>
            </Row>
          </Col>
        </Row>
      </Content>
    )
  }
}

export default withRouter(Government)
